export default __webpack_public_path__ + "static/media/aws-logo.e8faf3bd.svg";